module.exports = __webpack_public_path__ + "img/product-icon-3.8f441f17.png";